import type { OnlineCourseKitLine, OnlineCourseOption } from "@/lib/online-course-pricing";

export function kitPricePence(kit: OnlineCourseKitLine) {
  const value = kit.pricePence ?? (kit as { price_pence?: number }).price_pence;
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

export function normalizeKitLine(kit: OnlineCourseKitLine): OnlineCourseKitLine {
  return {
    ...kit,
    pricePence: kitPricePence(kit) || null,
    quantity: kit.quantity || 1,
    auto_add: Boolean(kit.auto_add ?? kit.autoAdd),
    shippingRequired: Boolean(kit.shippingRequired ?? kit.shipping_required),
  };
}

export function kitSelectionKey(kit: OnlineCourseKitLine) {
  const sku = (kit as { sku?: string }).sku;
  return `${kit.name}::${sku || ""}`;
}

export function getSelectableKits(
  kits: OnlineCourseKitLine[] = [],
): OnlineCourseKitLine[] {
  return kits.map(normalizeKitLine).filter((kit) => kitPricePence(kit) > 0);
}

export function optionHasKitPrompt(option: Pick<OnlineCourseOption, "required_kits">) {
  return getSelectableKits(option.required_kits).length > 0;
}

export function resolveCheckoutKits({
  availableKits = [],
  kitSelections = [],
  autoAddRequiredItems = false,
}: {
  availableKits?: OnlineCourseKitLine[];
  kitSelections?: OnlineCourseKitLine[];
  autoAddRequiredItems?: boolean;
}): OnlineCourseKitLine[] {
  const normalizedAvailable = availableKits.map(normalizeKitLine);

  if (kitSelections.length > 0) {
    const selectedKeys = new Set(kitSelections.map(kitSelectionKey));
    return normalizedAvailable.filter((kit) =>
      selectedKeys.has(kitSelectionKey(kit)),
    );
  }

  if (autoAddRequiredItems) {
    return normalizedAvailable.filter((kit) => kit.auto_add);
  }

  return [];
}
